import { BaseReceiptStatusDto } from '@api';

const baseInvoiceStatusDto: BaseReceiptStatusDto = {
  id: 0,
  status: '',
  created: '2021-01-01Z00:00:000Z',
  lastChange: '2021-01-01Z00:00:000Z',
};

export const INVOICE_STATUS: BaseReceiptStatusDto[] = [
  {
    ...baseInvoiceStatusDto,
    id: 1,
    status: 'Status A',
  },
  {
    ...baseInvoiceStatusDto,
    id: 2,
    status: 'Status B',
  },
  {
    ...baseInvoiceStatusDto,
    id: 3,
    status: 'Status C',
  },
  {
    ...baseInvoiceStatusDto,
    id: 4,
    status: 'Status D',
  },
];
